export default __webpack_public_path__ + "static/media/icon_pin.75621ff0.PNG";